export const tableColumns = [
    {
        name: 'Transaction ID',
        selector: row => row.transaction_id,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
        {
        name: 'Razorpay Order ID',
        selector: row => row.razorpay_order_id,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Benificary Name',
        selector: row => row.object_name,
        sortable: true,
        center: true,
        maxWidth: '4.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Amount',
        selector: row => row.amount,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Convenience Fee',
        selector: row => row.convenience_fee,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Net Amount',
        selector: row => row.net_amount,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Date & Time',
        selector: row => row.date_time, 
        sortable: true,
        center: true,
        maxWidth: '3.5rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Payee',
        selector: row => row.payee_name,
        sortable: true,
        center: true,
        maxWidth: '3.5rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Payment Status',
        selector: row => row.payment_status,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    // {
    //     name: 'Action',
    //     selector: row => row.action,
    //     sortable: true,
    //     center: true,
    //     minWidth: '6.25rem',
    // },
];